require('./creditSituation.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
// @ helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
// @ commons
const { EmptyState } = require('commonsComponents/emptyState');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
// @ components
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
// @ constants
const { HYPHEN } = require('constants/index');

class CreditSituation extends React.Component {

    constructor(props) {
        super(props);
    }

    buildContentRows() {
        const { immCreditSituation } = this.props;

        const contentTable = [{
            title: formatText('creditSituation-investmentsValuation'),
            value: immCreditSituation.get('investmentsValuation')
        },{
            title: formatText('creditSituation-executionLimit'),
            value: immCreditSituation.get('executionLimit'),
            tooltipText: formatText('creditSituation-executionLimitTooltipText')
        },{
            title: formatText('creditSituation-guaranteeExcess'),
            value: immCreditSituation.get('guaranteeExcess'),
            tooltipText: formatText('creditSituation-guaranteeExcessTooltipText')
        },{
            title: formatText('creditSituation-maximumTransfer'),
            value: immCreditSituation.get('maximumTransfer')
        }];


        return contentTable.map((content, id) => {
            let tooltip;

            if (content.tooltipText) {
                tooltip= (
                    <OKTooltip
                        content={content.tooltipText}
                        placement="top"
                    />
                );
            }

            return (
                <OKTableRow key={id}>
                    <OKTableCell className="credit-situation__title">
                        {content.title}
                        {tooltip}
                    </OKTableCell>
                    <OKTableCell className="credit-situation__amount">
                        <OneLineSymbolAmount
                            amountObject={getPlainAmountObject(content.value)}
                            language={getLanguage()}
                            amountObjectFormatted={formatAmountObject(content.value)} />
                    </OKTableCell>
                </OKTableRow>
            );
        });

    }

    buildCreditSituation() {
        const { immCreditSituation } = this.props;
        const guaranteePercentage = immCreditSituation.get('guaranteePercentage') || HYPHEN;
        const contentRows = this.buildContentRows();

        return (
            <OKTable>
                <tbody>
                    <OKTableRow>
                        <OKTableCell className="credit-situation__title">
                            <FormattedText value="creditSituation-guaranteePercentage" />
                            <OKTooltip
                                content="creditSituation-guaranteePercentageTooltipText"
                                placement="top"
                            />
                        </OKTableCell>
                        <OKTableCell className="credit-situation__amount">
                            {guaranteePercentage}
                        </OKTableCell>
                    </OKTableRow>
                    {contentRows}
                </tbody>
            </OKTable>
        );
    }

    buildCreditSituationError() {
        const primaryText = formatText('creditSituation-requestError');

        return (
            <EmptyState primaryText={primaryText} iconType="nointernet-banking"/>
        );
    }

    render() {
        const { immCreditSituation } = this.props;
        const title = formatText('creditSituation-title');
        let creditSituation;

        if (immCreditSituation.get('isFetching')) {
            creditSituation = <LoadingSection />;
        } else if (immCreditSituation.get('error')) {
            creditSituation = this.buildCreditSituationError();
        } else if (immCreditSituation.get('fetchSuccess')) {
            creditSituation = this.buildCreditSituation();
        }

        return (
            <OKSectionBox title={title}>
                <section className="credit-situation">
                    {creditSituation}
                </section>
            </OKSectionBox>
        );
    }
}

CreditSituation.propTypes = {
    immCreditSituation: PropTypes.object.isRequired
};

module.exports = CreditSituation;
